import React, { useState } from "react"
import { motion } from "framer-motion"
import { apiPost } from "../utils/api"
import { useNotify } from "../components/NotificationComponent"

export default function ContactPage() {
    const [data, setData] = useState({
        fullName:'',
        email:'',
        message: ''
    })
    const { notify } = useNotify()
    const submitForm = (e) => {
        e.preventDefault()
        apiPost('get-in-touch/', data).then(res => {
            notify('Form has been submitted.')
        }).catch(err => {
            notify(err.response && err.response.data.detail ? err.response.data.detail : err.message)
        })
    }

    return(
        <div className="bg-gray-50 min-h-screen font-sans pt-20">
            <motion.section
                initial={{ opacity: 0, y: 40 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8 }}
                className="p-6 md:p-16 text-center"
            >
                <h2 className="text-4xl md:text-5xl font-bold mb-4 text-gray-800">
                Get in Touch
                </h2>
                <p className="text-gray-600 text-base md:text-lg max-w-2xl mx-auto">
                Whether you have a question about features, pricing, need a demo, or anything else — our team is ready to answer all your questions.
                </p>
            </motion.section>

            <motion.section
                initial={{ opacity: 0 }}
                whileInView={{ opacity: 1 }}
                viewport={{ once: true }}
                transition={{ delay: 0.2 }}
                className="py-12 px-4 md:px-16"
            >
                <div className="max-w-2xl mx-auto bg-white p-8 rounded-xl shadow-md">
                <form className="space-y-6" onSubmit={submitForm}>
                    <div>
                    <label className="block mb-1 font-medium text-gray-700">Full Name</label>
                    <input value={data.fullName} onChange={(e)=>setData({...data, fullName:e.target.value})} type="text" placeholder="John Doe" className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" />
                    </div>
                    <div>
                    <label className="block mb-1 font-medium text-gray-700">Email</label>
                    <input value={data.email} onChange={(e)=>setData({...data, email:e.target.value})} type="email" placeholder="you@example.com" className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" />
                    </div>
                    <div>
                    <label className="block mb-1 font-medium text-gray-700">Message</label>
                    <textarea value={data.message} onChange={(e)=>setData({...data, message:e.target.value})} rows="5" placeholder="How can we help you?" className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"></textarea>
                    </div>
                    <button type="submit" className="w-full bg-blue-600 text-white py-2 rounded-md font-semibold hover:bg-blue-700 transition">
                    Send Message
                    </button>
                </form>
                </div>
            </motion.section>
        </div>
    )
}